import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  button: {
    padding: '0',
    backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
    '-webkit-background-clip': 'text',
    color: 'transparent'
  }
})

type PropsType = {
  to: string
  text: string
}

const ButtonLink: FC<PropsType> = ({to, text}) => {
  const classes = useStyles()

  return (
    <Button
      size="small"
      component={Link}
      to={to}
      className={classes.button}
    >
      {text}
    </Button>
  )
}

export default ButtonLink
